import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Range } from '@navfleet/client/shared/models/common';
import { NotificationEventComment, NotificationEventData } from '@navfleet/client/shared/models/notification';
import { environment } from '@navfleet/shared/core/environment';
import { Observable } from 'rxjs';

export const NOTIFICATION_EVENT_API = `${environment.NAVFLEET_BACKEND}/api/v1/notifications/events`;
export const VESSEL_NOTIFICATION_EVENT_API = `${environment.NAVFLEET_BACKEND}/api/v1/vessels/notifications/events`;

@Injectable({
    providedIn: 'root',
})
export class FleetEventApi {
    private http = inject(HttpClient);

    public getNotificationEvents(period?: Range<string>, vesselIds?: number[]): Observable<NotificationEventData[]> {
        const url = period ? `${NOTIFICATION_EVENT_API}?from=${period.from}&to=${period.to}` : NOTIFICATION_EVENT_API;
        if (vesselIds && vesselIds.length > 0) {
            return this.http.post<NotificationEventData[]>(
                VESSEL_NOTIFICATION_EVENT_API,
                {
                    from: period?.from,
                    to: period?.to,
                    vesselIds,
                },
                {
                    responseType: 'json',
                }
            );
        }
        return this.http.get<NotificationEventData[]>(url, { responseType: 'json' });
    }

    public getActiveNotificationEvents(): Observable<NotificationEventData[]> {
        return this.http.get<NotificationEventData[]>(`${NOTIFICATION_EVENT_API}/active`, { responseType: 'json' });
    }

    public acknowledgeNotificationEvent(eventId: number): Observable<any> {
        return this.http.put<any>(
            `${NOTIFICATION_EVENT_API}/${eventId}/acknowledge`,
            { eventId },
            { responseType: 'json' }
        );
    }

    public unAcknowledgeNotificationEvent(eventId: number): Observable<any> {
        return this.http.put<any>(
            `${NOTIFICATION_EVENT_API}/${eventId}/un-acknowledge`,
            { eventId },
            { responseType: 'json' }
        );
    }

    public getNotificationComments(id: number): Observable<{ comments: NotificationEventComment[] }> {
        return this.http.get<{ comments: NotificationEventComment[] }>(`${NOTIFICATION_EVENT_API}/${id}/comments`, {
            responseType: 'json',
        });
    }

    public createNotificationComment(payload: {
        eventId: number;
        comment: string;
        sendToVessel: boolean;
        sendCC: boolean;
    }): Observable<NotificationEventComment> {
        return this.http.post<NotificationEventComment>(
            `${NOTIFICATION_EVENT_API}/${payload.eventId}/comments`,
            {
                eventId: payload.eventId,
                comment: payload.comment,
                sendToVessel: payload.sendToVessel,
                sendCC: payload.sendCC,
            },
            { responseType: 'json' }
        );
    }

    public updateNotificationComment(comment: NotificationEventComment): Observable<NotificationEventComment> {
        const { id, notificationEventId, comment: commentText } = comment;
        return this.http.put<any>(
            `${NOTIFICATION_EVENT_API}/${notificationEventId}/comments/${id}`,
            { eventId: notificationEventId, commentId: id, comment: commentText },
            { responseType: 'json' }
        );
    }

    public deleteNotificationComment(comment: NotificationEventComment): Observable<any> {
        const { id, notificationEventId } = comment;
        return this.http.delete<any>(`${NOTIFICATION_EVENT_API}/${notificationEventId}/comments/${id}`, {
            responseType: 'json',
        });
    }
}
